
<block-ui>
    <ng-container *ngIf="!loading" class="trans-overlay">
        <span id="main-router-outlet"><router-outlet></router-outlet></span>
    </ng-container>
</block-ui>
